import {CRAService} from './craService.js';
import {IFTAService} from './iftaService.js';
import {StateTaxService} from './statetaxService.js';
import {FuelTaxPrefService} from './fuelTaxPreferencesService.js';

export var FueltaxService = {
	craService: null,
	iftaService: null,
	stateTaxService: null,
	fuelTaxPrefService: null,

	getCRAService: function(){
		if (!this.craService) {
			this.craService = new CRAService();
		}
		return this.craService;
	},

	getIftaService: function(){
		if (!this.iftaService) {
			this.iftaService = new IFTAService();
		}
		return this.iftaService;
	},

	getStateTaxService: function(){
		if (!this.stateTaxService) {
			this.stateTaxService = new StateTaxService();
		}
		return this.stateTaxService;
	},
	
	getFuelTaxPrefService: function(){
		if (!this.fuelTaxPrefService) {
			this.fuelTaxPrefService = new FuelTaxPrefService();
		}
		return this.fuelTaxPrefService;
	}
	
};